import {
    Component,
    Input,
    inject,
    ChangeDetectionStrategy,
} from '@angular/core';

import { DxListComponent } from 'devextreme-angular/ui/list';
import { DxContextMenuComponent } from 'devextreme-angular/ui/context-menu';
import { AuthService } from '../../services';

@Component({
    selector: 'app-user-panel',
    templateUrl: 'user-panel.component.html',
    styleUrls: ['./user-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxContextMenuComponent, DxListComponent],
})
export class UserPanelComponent {
    private authService = inject(AuthService);

    @Input()
    menuItems: any;

    @Input()
    menuMode!: string;

    email = '';
    constructor() {
        this.authService.userInfo
            .then((attributes) => {
                this.email = attributes?.email || '';
            })
            .catch((err) => {
                console.error('Error fetching user attributes:', err);
            });
    }
}
